import React from 'react';
import {
  Box,
  Button,
  Container,
  Stack,
  Divider,
} from '@mui/material';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  Fab,
} from '@marageti/z4-lib';
import { ViewProps } from './types';
import { EditForm } from '../../../components/country-defaults';
import CountryCard from '../../../components/country-card';
import ConfirmDelete from '../../../components/confirm-delete';

const CountryDefaultsView = ({
  control,
  countryDefault,
  countryList,
  countryOptions,
  riskLevelOptions,
  editorState,
  error,
  errors,
  handleSubmit,
  onCancelDelete,
  onClickCreate,
  onClickDelete,
  onClickEdit,
  onClose,
  onConfirmDelete,
  onSubmit,
  register,
  settingToDelete,
  showModal,
  submissionError,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box
      sx={{
        py: { desktop: 6.5, mobile: 4.5 },
        pb: { desktop: 6.5 + 10.5, mobile: 4.5 + 10.5 }, // 10.5 * 8px spacing for 85px fab.
      }}
    >
      {error && (
        <ErrorBox>
          <ErrorTitle>
            There was an error on our end.
          </ErrorTitle>
          <ErrorMessage>
            {`Code: ${error.code}: ${error.message}`}
          </ErrorMessage>
        </ErrorBox>
      )}
      {countryDefault && (
        <CountryCard
          displayName="All Countries"
          minBudgetPPPD={countryDefault.minBudgetPPPD}
          minNights={countryDefault.minNights}
          onClickEdit={() => onClickEdit(countryDefault)}
          withNights
        />
      )}
      <Divider
        sx={{
          marginTop: 2,
          marginBottom: 2,
        }}
      />
      <Stack spacing={1} marginBottom={2}>
        { countryList && countryList.map((ele) => (
          <CountryCard
            key={ele.country}
            displayName={ele.country}
            minBudgetPPPD={ele.minBudgetPPPD}
            minNights={ele.minNights}
            onClickEdit={() => onClickEdit(ele)}
            onClickDelete={() => onClickDelete(ele)}
            withNights
          />
        ))}
      </Stack>
    </Box>
    <Fab
      anchorId="oryx-footer"
    >
      <Button
        variant="contained"
        sx={{
          minWidth: { mobile: '350px', desktop: 'fit-content' },
        }}
        onClick={onClickCreate}
      >
        New Default Setting
      </Button>
    </Fab>
    <EditForm
      control={control}
      countryOptions={countryOptions}
      riskLevelOptions={riskLevelOptions}
      editorState={editorState}
      errors={errors}
      handleSubmit={handleSubmit}
      onCancel={onClose}
      onSubmit={onSubmit}
      open={showModal}
      register={register}
      submissionError={submissionError}
    />
    <ConfirmDelete
      open={!!settingToDelete}
      onCancel={onCancelDelete}
      onRemove={onConfirmDelete}
      title={`Remove ${settingToDelete?.country || ''}?`}
      submissionError={submissionError}
    />
  </Container>
);

export default CountryDefaultsView;
